import { render, staticRenderFns } from "./Government_receipt.vue?vue&type=template&id=6f00b791&scoped=true&"
import script from "./Government_receipt.vue?vue&type=script&lang=js&"
export * from "./Government_receipt.vue?vue&type=script&lang=js&"
import style0 from "./Government_receipt.vue?vue&type=style&index=0&id=6f00b791&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f00b791",
  null
  
)

export default component.exports